// extracted by mini-css-extract-plugin
module.exports = {"dfp":"story-card-stack-m__dfp__3Z1t8"};